/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { SvgLoadingBlue, SvgEditLoaderWhite } from '@assets';
import RenderIf from '@components/RequestProject/RenderIf';
import LoadingWrapper from './styles/LoadingWrapper';

const LoadingBlock = (props: any) => (
  <LoadingWrapper style={props.style}>
    <RenderIf condition={!props.white}>
      <SvgLoadingBlue size={props.size} />
    </RenderIf>
    <RenderIf condition={!!props.white}>
      <SvgEditLoaderWhite size={props.size} />
    </RenderIf>
  </LoadingWrapper>
);

export default LoadingBlock;
